import styled from "styled-components";
import { MainInner } from "@/styles/global";

const CFTCWrapper = styled(MainInner)`
    margin-top: 48px;
    padding: 0;
`;

const CFTCGrid = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
`;

const CFTCRow = styled.div`
    width: 100%;
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
`;

const CFTCCard = styled.div`
    border-radius: 10px;
    border: 1px solid ${({ theme }) => theme.colors.stroke};
    background: #FFF;
    box-shadow: 0px 8px 24px 0px rgba(145, 145, 145, 0.06);
    flex: 1;
    min-height: 400px;
    padding-bottom: 20px;
    width: 100%;

    @media (max-width: 768px) {
        flex: 50%;
        width: 100%;
    }
`;

const SpinnerWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    margin-top: 20px;
`;

const Spinner = styled.div`
    border: 4px solid rgba(0, 0, 0, 0.1);
    border-left: 4px solid ${({ theme }) => theme.colors.darkBlue};
    border-radius: 50%;
    width: 70px;
    height: 70px;
    animation: spin 1s linear infinite;

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(360deg);
        }
    }
`;

const S = {
    CFTCWrapper,
    CFTCGrid,
    CFTCRow,
    CFTCCard,
    SpinnerWrapper,
    Spinner
};

export default S;
